import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Alert, Button, Icon } from '@pella/sash-framework';
import { useGlobalConfig } from '../../../hooks/use-global-config';
import { useShowroomUrls } from '../../../hooks/use-showroom-urls';
import { formatPhoneNumber } from '../../utilities/functions';
import { LoadingOverlay } from '../../';
import CustomerShowroomText from '../../template/branches/customer-showroom-text';

const LocalShowroomCard = ({ className }) => {
	const { rta_cards } = useGlobalConfig();
	const { newShowrooms, oldShowrooms } = useShowroomUrls();
	const locations = useSelector((state) => state.locations);
	const [showroomData, setShowroomData] = useState({});
	const [error, setError] = useState(null);
	const [status, setStatus] = useState('idle');

	useEffect(() => {
		setError(null);
		setStatus('loading');

		if (locations?.showrooms?.[0]) {
			setShowroomData(locations.showrooms[0]);
			setStatus('success');
		} else {
			setShowroomData({});
			setStatus('error');
			setError(locations?.error?.message);
		}
	}, [locations?.showrooms, locations?.error?.message]);

	const showroomLink = newShowrooms?.nodes?.find((url) => url.showroom_id === showroomData.store_number)?.url || oldShowrooms?.nodes?.find((url) => url.showroom_id === showroomData.store_number)?.url;
	const showroomName = newShowrooms?.nodes?.find((url) => url.showroom_id === showroomData.store_number)?.page_heading?.replace(/<\/?span[^>]*>/g, '') || showroomData.name;

	return (
		<div className={`localShowroom relative flex flex-col border border-gray-15 bg-white p-4 md:p-6 xl:p-10 ${className || ''}`}>
			{status === 'loading' && (
				<LoadingOverlay
					fixed={false}
					svgSize={200}
				/>
			)}

			{rta_cards?.card?.[1]?.heading && (
				<h3 className='localShowroom-heading mb-5 flex flex-row items-center text-lg md:mb-6 xl:mb-5 xl:text-xl'>
					{rta_cards.card[1].material_symbol && (
						<Icon
							name={rta_cards.card[1].material_symbol}
							className='localShowroom-icon mr-3 flex-none md:mr-4 xl:mr-2'
							size={32}
						/>
					)}

					<span>{rta_cards.card[1].heading}</span>
				</h3>
			)}

			{error && (
				<Alert
					type='error'
					hideClose
				>
					{error}
				</Alert>
			)}

			{showroomData?.store_number && (
				<div className='mb-5 md:mb-4 xl:mb-5 xl:px-6'>
					{showroomName && <p className='localShowroom-showroomName mb-1 font-bold'>{showroomName}</p>}

					<p className='m-0 text-gray-50'>
						{showroomData?.line_1 && <span className='localShowroom-showroomLine1 block'>{showroomData.line_1}</span>}
						{showroomData?.line_2 && <span className='localShowroom-showroomLine2 block'>{showroomData.line_2}</span>}
						{showroomData?.city && (
							<span className='localShowroom-showroomAddress block'>
								{showroomData.city}, {showroomData?.state} {showroomData?.postal_code}
							</span>
						)}
						{showroomData?.phone && <span className='localShowroom-showroomPhone block'>{formatPhoneNumber(showroomData.phone)}</span>}
					</p>

					{showroomData?.branch_type === 'trade' && (
						<CustomerShowroomText
							showroomData={showroomData}
							className='pt-3 md:pt-4 xl:pt-5'
						/>
					)}
				</div>
			)}

			{showroomData?.store_number && (
				<div className='localShowroom-ctaWrapper mt-auto xl:px-6'>
					<Button
						href={showroomLink}
						color='secondary'
						size='sm'
						wide
						className='localShowroom-cta'
					>
						{rta_cards?.card?.[1]?.cta_heading}
					</Button>
				</div>
			)}
		</div>
	);
};

LocalShowroomCard.propTypes = {
	className: PropTypes.string,
};

export default LocalShowroomCard;
